import axios from 'axios'
import { config } from "../Config/config"

const tinMedisService = {
    getAll: () => {
        const result = axios.get(config.apiUrl + '/tindakan')
        //ketika berhasil 
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        //untuk pesan errornya
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    

}

export default tinMedisService